/**
 * Created by Ivan on 07.07.2026
 */

const StickersPackView = function (packSpine, stickersAmount) {
    return Prefab.instantiate(bundles.stickers_reward_window.jsons.stickers_pack_prefab_json, { stickersAmount });
};
